import { DocsThemeConfig } from 'nextra-theme-docs'
import Logo from './src/components/logo'

/**
 * @see https://nextra.site/docs/docs-theme/theme-configuration
 */
const nextraConfig: DocsThemeConfig = {
	navigation: {
		next: true,
		prev: true
	},
	darkMode: true,
	footer: {
		component: null
	},
	logo: <Logo></Logo>,
	head: (
		<>
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			<meta name="description" content="ASTA: ASTA performs fully autonomous functional testing of enterprise applications." />
			<meta name="og:title" content="ASTA: Autonomous Software Testing Agent" />
			<style>{`
		  [id^="headlessui-listbox-option"] {
			text-indent: 0.75rem;
		  }
		  [id^="headlessui-listbox-option"] span {
			position: absolute;
			right: 0.75rem;
		  }
		  a[aria-current="true"][href="/docs"] {
    		display: none !important;
  		  }
		`}</style>
		</>
	),
	useNextSeoProps() {
		return {
			titleTemplate: '%s – ASTA'
		}
	},
	toc: {
		backToTop: true
	},
	editLink: {
		component: null
	},
	feedback: {
		content: null
	}
}

export default nextraConfig
